import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditModule } from '../../../shared/modules/edit.module';
import { SharedModule } from '../../../shared/modules/shared.module';
import { NgDragDropModule } from 'ng-drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { SharedInputModule } from '../../../shared/modules/shared-input.module';
import { ProductFoldersModule } from '../../../features/product-folders/product-folders.module';
import { ShContextMenuModule } from 'ng2-right-click-menu';
import { ContractRecurringJobsComponent } from './contract-recurring-jobs.component';
import { DateModule } from '../../../shared/components/forms/input/date/date.module';
import { MatExpansionModule } from '@angular/material';
import { CommonPaginationModule } from '../../../shared/components/listing/common/common-pagiation.module';
import { ContractRecurringJobsAssetTypeComponent } from './asset-types/asset-types.component';
import { AsBoxModule } from '../../../shared/external-libraries/ngx-advanced-searchbox/src/public_api';
import { OwlDateTimeModule } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    EditModule,
    SharedModule.forRoot(),
    NgDragDropModule.forRoot(),
    DragDropModule,
    SharedInputModule,
    ProductFoldersModule,
    ShContextMenuModule,
    DateModule,
    MatExpansionModule,
    CommonPaginationModule,
    AsBoxModule.forRoot(),
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
  ],
  exports: [
    ContractRecurringJobsComponent,
    ContractRecurringJobsAssetTypeComponent,
  ],
  declarations: [
    ContractRecurringJobsComponent,
    ContractRecurringJobsAssetTypeComponent,
  ],
  entryComponents: [
    ContractRecurringJobsComponent,
    ContractRecurringJobsAssetTypeComponent,
  ],
})
export class ContractRecurringJobsModule { }
